"use client";

import Script from "next/script";
import { useEffect, useState } from "react";

export default function MNTNTracking() {
  const [trackingSrc, setTrackingSrc] = useState("");

  useEffect(() => {
    let tdr = "";
    let plh = "";
    let location = "";

    try {
      tdr = document.referrer
        ? encodeURIComponent(document.referrer.substring(0, 2048))
        : "";
    } catch {}

    try {
      location =
        window.top && window.top.location === document.location
          ? document.location.href
          : window.top?.location.href || document.location.href;
    } catch {
      location = document.location.href;
    }

    try {
      plh = parent.location.href
        ? encodeURIComponent(parent.location.href.substring(0, 2048))
        : encodeURIComponent(location.substring(0, 2048));
    } catch {
      plh = encodeURIComponent(location.substring(0, 2048));
    }

    const src = `https://dx.mountain.com/spx?dxver=4.0.0&shaid=39637&tdr=${tdr}&plh=${plh}&cb=${Math.floor(
      Math.random() * 1e17
    )}&term=value`;

    setTrackingSrc(src);
  }, []);

  if (!trackingSrc) return null;

  return (
    <Script
      id="mntn-tracking"
      src={trackingSrc}
      strategy="afterInteractive"
      onLoad={() => console.log("MNTN Tracking pixel loaded and fired")}
      onError={(e) => console.error("MNTN Tracking pixel failed:", e)}
    />
  );
}
